import PropTypes from 'prop-types';

import { Box, Button, Typography} from '@mui/material';

import {
  confirmationPageSx,
  confirmationCardSx,
  successIconOuterSx,
  successIconSx,
  confirmationTitleSx,
  confirmationTextSx
} from '../../Common/components/Styles/AuthStyles';

import { SuccessIcons } from '../../Common/components/Icons/icons';

const ConfirmationView = ({
  firstName,
  onSignIn
}) => {
  return (
    <Box sx={confirmationPageSx}>
      <Box sx={confirmationCardSx}>
        <Box sx={successIconOuterSx}>
          <Box sx={successIconSx}>
            <SuccessIcons />
          </Box>
        </Box>

        <Typography sx={confirmationTitleSx}>
          Thanks for signing up.
        </Typography>

        <Typography sx={confirmationTextSx}>
          Hi, <strong>{firstName}</strong>, an account activation
          email has been sent to your registered email address.
        </Typography>

        <Typography sx={confirmationTextSx}>
          Please check your inbox and click on the link in the message to
          confirm and activate your account.
        </Typography>

        <Button
          fullWidth
          onClick={onSignIn}
          variant="contained"
        >
          Sign In Now
        </Button>
      </Box>
    </Box>
  );
};

ConfirmationView.propTypes = {
  firstName: PropTypes.string.isRequired,
  onSignIn: PropTypes.func.isRequired
};

export default ConfirmationView;